import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, IconButton, Switch, Table, Tbody, Td, Text, Th, Thead, Tooltip, Tr } from '@chakra-ui/react';
import { createColumnHelper, flexRender, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { toast } from 'components/Toast';
import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import AuthorizationComponentWrapper from 'components/AuthorizationComponentWrapper/AuthorizationComponentWrapper';
import { useUserState } from 'context/UserContext';
import { ModalType } from 'constants/common';
import { useChangeStatusBrandingMutation, useDeleteBrandingMutation } from 'services/branding';
import { FaRegCopy } from 'react-icons/fa';

function BrandingTable({ brandingData, handleUpdateItem, refetch }) {
  const deleteBrandingMutation = useDeleteBrandingMutation();
  const changeStatusBrandingMutation = useChangeStatusBrandingMutation();
  const [sorting, setSorting] = useState([]);
  const { userInfo } = useUserState();
  // const [checked, setChecked] = useState(false);

  const handleRowClick = (brading, type) => {
    handleUpdateItem(brading, type);
  };

  const handleDeleteBranding = async brandingDetail => {
    const confirmDelete = window.confirm('Bạn có chắc chắn muốn xóa Thương Hiệu này không?');
    if (!confirmDelete) {
      return;
    }
    deleteBrandingMutation.mutate(
      { brandingId: brandingDetail?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Xóa Thương Hiệu không thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Xóa Thương Hiệu không thành công');
          refetch?.();
        },
      }
    );
  };
  const columnHelper = createColumnHelper();
  const [rowSelection, setRowSelection] = useState([]);
  const onRowSelectionChange = newSelection => setRowSelection(newSelection);
  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: 'Tên Thương hiệu',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('isActive', {
        header: 'Kích Hoạt',
        cell: info => (
          <Box w={'fit-content'}>
            <Switch
              isChecked={info.getValue()}
              onChange={() => {
                handleChangeIsActive(info?.row?.original);
              }}
            ></Switch>
          </Box>
        ),
      }),
      columnHelper.accessor('apiKey', {
        header: 'Apikey',
        cell: info => (
          <Flex justifyItems={'center'} alignItems={'center'}>
            <Text fontSize={14}>{info.getValue()}</Text>
            <Tooltip label="Copy" placement="right" hasArrow bg="gray.300" color="black" fontSize="sm">
              <IconButton
                bg="transparent"
                onClick={() => {
                  navigator.clipboard.writeText(info.getValue());
                }}
              >
                <FaRegCopy cursor="pointer" />
              </IconButton>
            </Tooltip>
          </Flex>
        ),
      }),

      columnHelper.accessor('action', {
        header: 'Thao tác',
        cell: info => (
          <Flex alignItems="center" gap={1}>
            <IconButton
              bg="transparent"
              onClick={() => {
                handleRowClick(info?.row?.original, ModalType.Add);
              }}
            >
              <EditIcon cursor="pointer" boxSize={4} />
            </IconButton>
            <IconButton
              bg="transparent"
              onClick={() => {
                handleDeleteBranding(info?.row?.original);
              }}
            >
              <DeleteIcon color="red.400" boxSize={4} />
            </IconButton>
          </Flex>
        ),
      }),
    ],
    [brandingData]
  );

  const handleChangeIsActive = branding => {
    const confirmDelete = window.confirm('Bạn có chắc chắn muốn thay đổi trạng thái của Thương Hiệu này không?');
    if (!confirmDelete) {
      return;
    }
    changeStatusBrandingMutation.mutate(
      {
        brandingId: branding?._id,
      },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Đổi trạng thái thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Đổi trạng thái thất bại');
          refetch?.();
        },
      }
    );
  };

  var table = useReactTable({
    data: brandingData || [],
    columns,
    state: {
      sorting,
      rowSelection,
    },
    onSortingChange: setSorting,
    onRowSelectionChange,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
    enableRowSelection: true,
    getRowId: row => {
      return row._id;
    },
  });

  return (
    <>
      <Table>
        <Thead>
          {table.getHeaderGroups().map(headerGroup => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <Th key={header.id}>
                  {header.isPlaceholder ? null : (
                    <Box w={'fit-content'} cursor={header.column.getCanSort() ? 'pointer' : 'default'}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {/* {{
                        asc: ' 🔼',
                        desc: ' 🔽',
                      }[header.column.getIsSorted()] ?? null} */}
                    </Box>
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {isEmpty(table.getRowModel().rows) ? (
            <Tr>
              <Td textAlign="center" colSpan={5}>
                Không có dữ liệu
              </Td>
            </Tr>
          ) : (
            table.getRowModel().rows.map(row => (
              <Tr key={row.id}>
                {row.getVisibleCells().map(cell => (
                  <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
                ))}
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </>
  );
}
export default BrandingTable;
